import { useState, useRef, useEffect } from "react"
import useLocalStorageState from "use-local-storage-state"

const IMG_BASE = "https://image.tmdb.org/t/p/w780"

export default function FavoriteCard({ movie, onClick, isActive }) {
  const [menuOpen, setMenuOpen] = useState(false)
  const menuRef = useRef(null)
  const [, setLikedMovies] = useLocalStorageState("likedMovies", { defaultValue: [] })

  useEffect(() => {
    if (!menuOpen) return
    function handle(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false)
      }
    }
    document.addEventListener("mousedown", handle)
    return () => document.removeEventListener("mousedown", handle)
  }, [menuOpen])

  const removeFromFavorites = () => {
    setLikedMovies((prev) => prev.filter((m) => m.id !== movie.id))
    setMenuOpen(false)
  }

  const backdrop = movie.backdrop_path
    ? `${IMG_BASE}${movie.backdrop_path}`
    : movie.poster_path
    ? `https://image.tmdb.org/t/p/w500${movie.poster_path}`
    : null

  return (
    <div className="flex-shrink-0 w-56 cursor-pointer group/card">
      {/* Image */}
      <div
        onClick={() => onClick(movie)}
        className={`relative aspect-video rounded-lg overflow-hidden bg-zinc-800 transition-all duration-200
          ${isActive ? "ring-2 ring-yellow-400" : "hover:ring-2 hover:ring-white"}`}
      >
        {backdrop ? (
          <img
            src={backdrop}
            alt={movie.title}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-zinc-500 text-xs text-center px-2">
            {movie.title}
          </div>
        )}

        {/* Three-dot menu */}
        <div
          ref={menuRef}
          className="absolute top-1.5 right-1.5 opacity-0 group-hover/card:opacity-100 transition-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={() => setMenuOpen((o) => !o)}
            className="w-7 h-7 flex items-center justify-center rounded-full bg-black/60 hover:bg-black/80 text-white transition-colors"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
            </svg>
          </button>

          {menuOpen && (
            <div className="absolute top-8 right-0 w-44 bg-zinc-900 rounded-xl shadow-xl border border-zinc-800 overflow-hidden z-50">
              <button
                onClick={() => { onClick(movie); setMenuOpen(false) }}
                className="w-full flex items-center gap-3 px-4 py-3 text-sm text-zinc-200 hover:bg-zinc-800 transition-colors"
              >
                <svg className="w-4 h-4 text-zinc-400 shrink-0" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8 5v14l11-7z" />
                </svg>
                Watch
              </button>
              <div className="border-t border-zinc-800" />
              <button
                onClick={removeFromFavorites}
                className="w-full flex items-center gap-3 px-4 py-3 text-sm text-zinc-200 hover:bg-zinc-800 transition-colors"
              >
                <svg className="w-4 h-4 text-zinc-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                Remove
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Title */}
      <p
        onClick={() => onClick(movie)}
        className={`mt-1.5 text-sm leading-snug line-clamp-1 px-0.5 ${
          isActive ? "text-yellow-400 font-semibold" : "text-zinc-300 hover:text-white"
        }`}
      >
        {movie.title}
      </p>
    </div>
  )
}
